<template>
  <div class="row">
    <div class="col-2 b-form__container_min-width_200">
      <div>
        <div>
          <label>
            {{$t('CONTENT.payments.payment_frequency')}}:
            <span class="b-form__required">*</span>
          </label>
          <cool-select
            :list="getFrequencies"
            option-value="value"
            option-text="text"
            :placeholder="$t('CONTENT.choose')"
            v-model="newPaymentFrequency"
          ></cool-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChangePaymentFrequency from "../../models/commands/ChangePaymentFrequency";
import dateConverter from "@/utils/converters/date.converter";
import { mapGetters } from "vuex";

export default {
  components: {},
  props: {
    paymentParams: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      newPaymentFrequency: null
    };
  },
  computed: {
    ...mapGetters(["getFrequencies"])
  },
  created() {
    this.newPaymentFrequency = this.paymentParams.paymentFrequency;
  },
  methods: {
    cancel() {
      this.newPaymentFrequency = this.paymentParams.paymentFrequency;
    },

    save() {
      const command = new ChangePaymentFrequency(
        this.paymentParams.idInDB,
        this.newPaymentFrequency
      );
      this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      return true;
    }
  }
};
</script>

<style>
</style>
